<template>
	<a v-if="notRoot" :href="url" @click="handleNonRootClick"><slot></slot></a>
	<router-link v-else-if="isRouter && !confirmed" :to="url"><slot></slot></router-link>
	<span v-else-if="isEmpty"><slot></slot></span>
	<a v-else :href="url" :target="target"><slot></slot></a>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import {isRoute} from "@/router/Router";
import { useRouter } from "vue-router";
import {addContextParams, injectContext} from "@t/fd/AppContext.ts";

const props = defineProps<{
	to?: string,
	target?: string,
	confirmed?: boolean,
	/** Add context parameters to the given URL */
	ctx?:boolean|string[]
}>();

const router = useRouter();

const notRoot = !Server.appRootWindow;

const isRouter = computed(() => {
	return isRoute(props.to);
});

const isEmpty = computed<boolean>(() => props.to == null || props.to.length === 0);

const url = computed(() => {
	let url = props.to;
	if (props.ctx) {
		const ctxMap = injectContext();
		url = addContextParams(url, ctxMap.value, props.ctx);
	}
	return url;
});

/** Programmatic navigation of the link */
function navigate() {
	if (isRouter.value) {
		// use logic for <router-link>
		router.push(url.value);
	} else {
		// use logic for <a>
		window.location.href = url.value;
	}
}

function handleNonRootClick(e:MouseEvent) {
	e.preventDefault();
	// This is not the root window. A top-level window has parent === self,
	// so a window opened by window.open() must be reached through opener.
	let w:Window|null = window.opener;
	while (w != null) {
		// @ts-ignore
		if (w.Server.appRootWindow) {
			// @ts-ignore
			w.Server.tools.navigate(url.value);
			return;
		}
		const next = w.opener && w.opener !== w ? w.opener : null;
		w = next;
	}
	// Root not found
	navigate();
}

defineExpose({
	navigate
});
</script>

<style>

</style>